/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import { getInsightContentData } from './asyncThunks'
import { InsightContentSlice } from './types'

export const ERROR_MESSAGE = { REQUEST_CANCELLED: 'RequestCancelled' }

const initialState: Readonly<InsightContentSlice> = {
  contents: {},
  status: 'idle',
  error: null
}

const insightContentSlice = createSlice({
  name: 'insightContent',
  initialState,
  reducers: {
    resetInsightContent: (state) => {
      state.contents = {}
      state.status = 'idle'
      state.error = null
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(getInsightContentData.pending, (state, action) => {
        state.contents[action.meta.arg.insightContentType] =
          state.contents[action.meta.arg.insightContentType] || {}
        state.contents[action.meta.arg.insightContentType].status = 'loading'
        state.contents[action.meta.arg.insightContentType].data = undefined
      })
      .addCase(getInsightContentData.fulfilled, (state, action) => {
        state.contents[action.meta.arg.insightContentType].data = action.payload.data || []
        state.contents[action.meta.arg.insightContentType].status = 'succeeded'
        state.contents[action.meta.arg.insightContentType].isRetry = action.payload.shouldRetry
      })
      .addCase(getInsightContentData.rejected, (state, action) => {
        // Ignore response from the cancelled request.
        if (action.error.message === ERROR_MESSAGE.REQUEST_CANCELLED) {
          return
        }
        state.contents[action.meta.arg.insightContentType] =
          state.contents[action.meta.arg.insightContentType] || {}
        state.contents[action.meta.arg.insightContentType].status = 'failed'
        if (action.payload) {
          state.contents[action.meta.arg.insightContentType].error = action.payload
        } else {
          state.contents[action.meta.arg.insightContentType].error = action.error
        }
      })
})

export const { resetInsightContent } = insightContentSlice.actions
export default insightContentSlice.reducer
